<template>
  <div class="container">
    <div class="row">
      <h4>Cerrando sessión ...</h4>
    </div>
  </div>
</template>

<script>
 import { mapState, mapActions, mapMutations } from 'vuex';

 export default {
   name: 'logout',

   methods: {
     ...mapActions({
       purge_session: 'UserSession/purge_session',
     }),

     ...mapMutations(['RESET_STATE']),
   },

   mounted: function() {
     // Delete data from state
     this.RESET_STATE();
     this.$http
         .post(this.$base + '/api/v1/rest-auth/logout/', {})
         .then(response => {
           this.purge_session()
           this.$auth.logout();
           this.$router.push('login')
         })
         .catch(err => {
           console.log(err)
           this.$auth.logout()
           this.$router.push('login')
         })
   },
 }
</script>
